interface YotpoState {
  storeId: string;
  galleryId: string;
  galleryIdMobile: string;
  reviewInstanceId: string;
}

const DEFAULT_STATE: YotpoState = {
    storeId: "",
    galleryId: "",
    galleryIdMobile: "",
    reviewInstanceId: ""
  };

export const yotpo = (
    state = DEFAULT_STATE,
  ): YotpoState => {
        return state;
  };